'use client';
import { useEffect } from 'react';

export default function PWAServiceWorkerRegistration() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker?.register('/sw.js', { scope: '/' })?.then((registration) => {
            console.log('[PWA] Service Worker registered:', registration?.scope);

            // Check for updates
            registration?.addEventListener('updatefound', () => {
              const newWorker = registration?.installing;
              if (newWorker) {
                newWorker?.addEventListener('statechange', () => {
                  if (newWorker?.state === 'installed' && navigator.serviceWorker?.controller) {
                    console.log('[PWA] New version available');
                  }
                });
              }
            });
          })?.catch((err) => {
            console.warn('[PWA] Service Worker registration failed:', err);
          });
      });
    }
  }, []);

  return null;
}
